import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { colours } from "utils";
import { CXL } from "@/components/Typography";

type StyleProps = {
  colour?: string;
};

type StepForwardInfoStripProps = {
  children: React.ReactNode;
  colour?: string;
  textColour?: string;
};

const StepForwardInfoStrip: FunctionComponent<StepForwardInfoStripProps> = (
  props
) => {
  return (
    <S.Container {...props}>
      <CXL colour={props.textColour}>{props.children}</CXL>
    </S.Container>
  );
};

const S = () => {};

S.Container = styled.section<StyleProps>`
  position: relative;
  width: 100%;
  padding: 15px 10%;
  background: ${(p) => p.colour || colours.shell};
  display: flex;
  justify-content: center;
`;

export default StepForwardInfoStrip;
